import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { postData } from 'src/api/api-utilities'
import { useToastAlert } from 'src/stores/ToastContext'
import { getQueryConfig } from 'src/utils/helpers/VirtualPortalHelpers'

const postComplete = async (config) => {
  const response = await postData('/virtual_portal/complete_event_one_on_one_meeting_wishlists',
    null,
    config
  )
  if (response.status < 200 || response.status > 300) {
    const error = new Error('Error')
    error.code = response.status
    error.info = response.data
    error.text = response.statusText
    throw error
  }
  return response
}

const usePostCompleteWishlist = () => {
  const navigate = useNavigate()
  const config = getQueryConfig()
  const queryClient = useQueryClient()
  const { setAlert } = useToastAlert()
  const { mutateAsync, mutate } = useMutation({
    mutationFn: () => postComplete(config),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['event_one_on_one_timeslot'] })
      navigate(`${location.pathname.replace('availability', 'thankyou')}${location.search}`)
    },
    onError: (error) => {
      setAlert({
        status: error.code,
        title: error.message,
        message: error.info || error.text,
        forceLogout: false
      })
    }
  })

  return { mutateAsync, mutate }
}

export default usePostCompleteWishlist
